var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIphone250DpFfffffFill0Wght200Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.38-80q-23.05 0-39.22-16.16Q240-112.33 240-135.38v-689.24q0-23.05 16.16-39.22Q272.33-880 295.38-880h369.24q23.05 0 39.22 16.16Q720-847.67 720-824.62v689.24q0 23.05-16.16 39.22Q687.67-80 664.62-80H295.38Zm-24.61-155.38v100q0 9.23 7.69 16.92 7.69 7.69 16.92 7.69h369.24q9.23 0 16.92-7.69 7.69-7.69 7.69-16.92v-100H270.77Zm209.42 88.07q10.5 0 18.23-7.52t7.73-18.42q0-10.9-7.92-18.63-7.92-7.74-18.42-7.74-10.5 0-18.23 7.92t-7.73 18.41q0 11.29 7.92 18.64 7.92 7.34 18.42 7.34ZM270.77-266.15h418.46v-496.93H270.77v496.93Zm0-527.7h418.46v-30.77q0-9.23-7.69-16.92-7.69-7.69-16.92-7.69H295.38q-9.23 0-16.92 7.69-7.69 7.69-7.69 16.92v30.77Zm0 558.47v124.61-124.61Zm0-558.47V-849.23v55.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIphone250DpFfffffFill0Wght200Grad0Opsz48);
export default __webpack_public_path__ + "static/media/phone_iphone_250dp_FFFFFF_FILL0_wght200_GRAD0_opsz48.3308a2783a9de4ba7e83a9d035036707.svg";
export { ForwardRef as ReactComponent };